import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type DestinoFormStylesType = {
  destinoForm: SxProps
}

export const destinoFormStyles: DestinoFormStylesType = {
  destinoForm: {
    marginTop: 0,
    paddingTop: 0,
    justifyContent: 'center',

    '& .MuiGrid-item': {
      paddingTop: theme.spacing(0.5)
    }
  }
}
